<script lang="ts" setup>
export interface DocumentsTableSimpleRowProps {
    document: Document;
}

export interface DocumentsTableSimpleRowEmits {
    (e: 'open-pdf', src: string): void;
}

const props = defineProps<DocumentsTableSimpleRowProps>()
const emit = defineEmits<DocumentsTableSimpleRowEmits>()

const { $t } = useNuxtApp()

const documentLabel = computed((): string => {
    return [
        props.document.filename,
        props.document.document.extension,
        props.document.document.size_human,
    ].filter(Boolean).join(', ')
})

const handleClick = async (): Promise<void> => {
    try {
        await useDownload({
            url: props.document.document.path,
            filename: `${props.document.filename}.pdf`,
        })
    } catch (error: any) {
        if (error instanceof Error) {
            showError({ statusCode: 404, message: $t('Súbor neexistuje.') })
            useScrollIntoView(document.body)
        }
    }
}

const handleClickOnDocumentTitle = (
    e: MouseEvent,
    document: Document
): void => {
    if (
        !document.show_pdf_as_booklet ||
        window.matchMedia('(max-width: 425px)').matches
    )
        return
    e.preventDefault()
    emit('open-pdf', document.document.path)
}
</script>
<template>
  <tr
    data-document-row
    tabindex="-1"
    class="documents-table-simple-row text-hover-secondary px-4"
  >
    <td
      class="documents-table-simple-row-cell text-start py-2 px-4 transition"
    >
      <Tracker :data="{ title: props.document.filename }">
        <div
          class="documents-table-simple-title d-flex align-items-center"
        >
          <svg
            class="me-2 text-secondary flex-shrink-0 mw-100 mh-100"
            width="12"
            height="16"
            aria-hidden="true"
          >
            <use xlink:href="#file" />
          </svg>
          <VNuxtLink
            :to="props.document.document.path"
            data-preview-disabled="true"
            target="_blank"
            type="application/pdf"
            class="fs-smaller text-black text-hover-secondary text-decoration-underline"
            :aria-label="`${$t('Otvoriť dokument')} ${documentLabel}`"
            @click="(e: MouseEvent) => handleClickOnDocumentTitle(e, document)"
          >
            {{ documentLabel }}
          </VNuxtLink>
        </div>
      </Tracker>
    </td>
    <td
      class="documents-table-simple-row-cell d-none d-md-table-cell text-secondary text-nowrap text-end py-2 px-4 transition"
    >
      <VNuxtLink
        :to="props.document.document.path"
        target="_blank"
        data-preview-disabled="true"
        class="fs-xsmall text-secondary d-flex align-items-center justify-content-end text-decoration-underline"
        :aria-label="`${$t('Stiahnuť')} ${documentLabel}`"
        @click.prevent="handleClick"
      >
        {{ $t("Stiahnuť") }}

        <svg
          class="text-secondary ms-2"
          width="12"
          height="16"
          aria-hidden="true"
        >
          <use xlink:href="#download" />
        </svg>
      </VNuxtLink>
    </td>
  </tr>
</template>

<style lang="scss" scoped>
@import "./DocumentsTableSimpleRow.scss";
</style>
